<div class="app-body">
    <main class="main d-flex align-items-center">
        <div class="container">
            <div class="row">
                <div class="col-md-8 offset-md-2 mx-auto">
                    <form [formGroup]="form">
                        <div class="card-group">
                            <div class="card p-4">
                                <div class="card-body">
                                    <div class="logo"></div>
                                    <div class="m-2" style="color: red">
                                        {{ 'shell.reset_instructions' | transloco }}
                                    </div>
                                    <!-- ユーザの有無でメッセージを変えない (アカウント列挙の防止, issue #171) -->
                                    <div *ngIf="sent" class="alert alert-info m-2">
                                        {{ 'shell.reset_sent' | transloco }}<br>
                                        {{ 'shell.reset_sent_hint' | transloco }}
                                    </div>
                                    <div class="input-group mb-1" [ngClass]="{'has-danger': formHelper.hasErrorTooltip(form, username,'username')}" [tooltip]="'shell.username_min3' | transloco" triggers="" #username="bs-tooltip" placement="right">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text"><i class="icon-user"></i></span>
                                        </div>
                                        <input type="text" class="form-control" formControlName="username" [ngClass]="{'form-control-danger':formHelper.hasError(form, 'username')}" [placeholder]="'shell.username_or_email' | transloco">
                                    </div>
                                    <div class="row">
                                        <div class="col-12">
                                            <button type="button" class="btn btn-primary btn-block" [disabled]="!form.valid" (click)="reset(form.value)">{{ 'shell.send' | transloco }}</button>
                                        </div>
                                    </div>
                                    <div class="row mt-2">
                                        <div class="col-12">
                                            {{ 'shell.login_prefix' | transloco }}<a [routerLink]="['/login']">{{ 'shell.here_link' | transloco }}</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </main>
</div>
